import { Link, Navigate } from 'react-router-dom'

import { Netzstreifen } from '../../components/Netzstreifen'
import { BackIcon } from '../../components/Icons'
import { useMe } from '../../hooks/queries'
import { Kategorien, type Kategorie } from './Kategorien'
import { ChatfarbenCard } from './ChatfarbenCard'
import { DiensteCard } from './DiensteCard'
import { ErkennungCard } from './ErkennungCard'
import { GifCard } from './GifCard'
import { KnopffarbeCard } from './KnopffarbeCard'
import { LimitsCard } from './LimitsCard'
import { MedienCard } from './MedienCard'
import { Personenliste } from './PeoplePage'
import { SpeicherCard } from './SpeicherCard'

/**
 * Die Verwaltung — alles, was die **ganze Installation** betrifft (#39).
 *
 * Aus dem Issue: „eigene Verwaltungsseite - nur für Benutzer mit
 * Admin-Rechten." Vorher hing das alles unter den persönlichen Einstellungen
 * untereinander: das eigene Konto neben Grenzen, Farben und Diensten, die für
 * jeden gelten. Wer nur seine Schriftgröße ändern wollte, scrollte an der
 * Aufenthaltserkennung vorbei.
 *
 * **Die Weiterleitung ist Bequemlichkeit, keine Sperre.** Entschieden wird im
 * Server — `requireAdmin` in `SettingsController` und `PeopleController`, und
 * `/api/settings` liefert die Decke ohnehin nur der Verwaltung. Hier wird
 * niemand ferngehalten, hier wird nur niemandem eine Seite gezeigt, auf der
 * jede Karte leer bliebe.
 */
export function VerwaltungPage() {
  const me = useMe()

  // Solange `me` nicht dasteht, wird nicht weitergeleitet: sonst flöge jeder
  // beim Neuladen kurz hinaus, weil die Antwort noch unterwegs ist.
  if (me.data !== undefined && !me.data.may_manage_people) {
    return <Navigate to="/settings" replace />
  }

  const kategorien: Kategorie[] = [
    { schluessel: 'personen', titel: 'Personen', inhalt: () => <Personenliste /> },
    {
      schluessel: 'speicher',
      titel: 'Speicherplatz',
      inhalt: () => (
        <>
          <SpeicherCard />
          {/* Beides sieht auf denselben Bestand: was liegt da, und ist es
              überall abspielbar. */}
          <MedienCard />
        </>
      ),
    },
    { schluessel: 'grenzen', titel: 'Bilder, Videos, Platz', inhalt: () => <LimitsCard /> },
    {
      schluessel: 'farben',
      titel: 'Farben',
      inhalt: () => (
        <>
          <ChatfarbenCard />
          <KnopffarbeCard />
        </>
      ),
    },
    { schluessel: 'erkennung', titel: 'Aufenthalte erkennen', inhalt: () => <ErkennungCard /> },
    { schluessel: 'dienste', titel: 'Ort und Wetter', inhalt: () => <DiensteCard /> },
    { schluessel: 'gifs', titel: 'GIFs in Antworten', inhalt: () => <GifCard /> },
  ]

  return (
    <>
      <Netzstreifen />
      <Kategorien
        titel="Verwaltung"
        zurueck={
          <Link className="icon-button" to="/settings" aria-label="Zurück">
            <BackIcon />
          </Link>
        }
        kategorien={kategorien}
      />
    </>
  )
}
